import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';


export interface Referidos{
  auth_key:string,
  data:[{
    ref:any[],
    crono_uso:number,
    crono_disp:number
  }]
}
@Injectable({
  providedIn: 'root'
})
export class ReferidosService {

  constructor(private http: HttpClient) { }

  get(id,auth_key){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':auth_key});
    postData.push({'id':id});
    return this.http.post(environment.urlReferidos+'?opcion=1', JSON.stringify(postData));
    /********************** */
  }
}
